export const CheckHandedIn = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="icon"
    aria-hidden="true"
    focusable="false"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.2068 11.654C7.81628 11.2635 7.18311 11.2635 6.79259 11.654L6.50471 11.9418C6.11419
       12.3324 6.11419 12.9655 6.50471 13.3561L10.1968 17.0481C10.5873 17.4386 11.2205 17.4386
        11.611 17.0481L18.7072 9.95189C19.0977 9.56136 19.0977 8.9282 18.7072 8.53767L18.4193
         8.2498C18.0288 7.85928 17.3956 7.85928 17.0051 8.2498L10.9039 14.351L8.2068 11.654Z"
      fill="#004597"
    />
  </svg>
);
